import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import { useDispatch } from "react-redux";
import TableImage from "../../shared/TableCard/TableImage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { EnableDisableUserAction } from "../../redux/actions/userAction";

export default function UserTable({ heading, allUsers, loading, history, search, setSearch, onDelete, headerContent, selection = false }) {
    const dispatch = useDispatch();
    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`users/view/${d._id}`)}></i>
                <i className="pi pi-pencil cursor-pointer" onClick={() => history.push(`users/edit/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer" onClick={(e) => onDelete(e, d._id)}></i>
            </div>
        );
    };

    const handleSwitchChange = (id) => {
        dispatch(EnableDisableUserAction(id));
    };

    const isActive = (rowData) => {
        return (
            <div className="flex">
                <InputSwitch checked={rowData.isActive} onChange={() => handleSwitchChange(rowData?._id)} />
            </div>
        );
    };

    const image = (r) => {
        const image = r.image;
        return <TableImage image={image} />;
    };
    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
                mask="99/99/9999"
            />
        );
    };
    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };
    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search} headerContent={headerContent()}>
                <DataTable
                    paginator
                    value={allUsers}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage="No user found."
                >
                    {selection ? <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column> : null}
                    <Column body={(rowData) => rowData.fullName} header="Full Name"></Column>
                    <Column field="email" header="Email" style={{ width: "250px" }}></Column>
                    <Column field="mobile" header="Mobile" style={{ width: "250px" }}></Column>
                    <Column
                        header="Create At"
                        field="time"
                        dataType="date"
                        style={{ minWidth: "10rem" }}
                        filterMatchMode="dateIs"
                        showFilterMatchModes={true}
                        body={(rowData) => formatDate(rowData.time)}
                        filter
                        filterElement={dateFilterTemplate}
                    />
                    <Column body={image} header="Image" style={{ width: "80px" }}></Column>
                    <Column header="Active" body={isActive} style={{ width: "80px" }}></Column>
                    <Column body={actions} style={{ width: "100px" }} header="Action"></Column>
                </DataTable>
            </TableCard>
        </>
    );
}
